import { apiClient } from '../../../lib/apiClient';

export interface RecipeIngredient {
  item: { id: string; name: string; sku: string; unit: string; minStock?: number };
  qty: number;
  unit: string;
  notes?: string;
}

export interface ProductRecipe {
  _id: string;
  productId: string;
  name?: string;
  ingredients: RecipeIngredient[];
  active: boolean;
  createdAt: string;
}

export interface UpsertRecipePayload {
  productId: string;
  name?: string;
  ingredients: {
    itemId: string;
    qty: number;
    unit: string;
    notes?: string;
  }[];
}

export const listRecipes = async (): Promise<ProductRecipe[]> =>
  (await apiClient.get<ProductRecipe[]>('/inventory/recipes')).data;

export const getRecipe = async (productId: string): Promise<ProductRecipe> =>
  (await apiClient.get<ProductRecipe>(`/inventory/recipes/${productId}`)).data;

export const upsertRecipe = async (payload: UpsertRecipePayload): Promise<ProductRecipe> =>
  (await apiClient.post<ProductRecipe>('/inventory/recipes', payload)).data;
